
<div class="row text-center">
  <div class="col-10 offset-1">
    <div class="mt-5" *ngIf="orientation === 'landscape'">
      <h3 class="text-secondary"> Ruota il tuo dispositivo</h3>
      <p>Per usufruire al meglio questa interazione ruota il tuo dispositivo</p>
      <img src="assets/images/default/portrait-to-landscape.png" width="200px" class="mt-5 mb-5 img-fluid"/>
    </div>
    <div class="mt-5" *ngIf="orientation === 'portrait'">
      <h3 class="text-secondary"> Ruota il tuo dispositivo</h3>
      <p>Per usufruire al meglio questa interazione ruota il tuo dispositivo</p>
      <img src="assets/images/default/landscape-to-portrait.png" width="200px"   class="mt-5 mb-5 img-fluid"/>
    </div>
  </div>
</div>


